// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".article-reactions-widget-module__container--1gg_-{padding:20px;position:relative}.article-reactions-widget-module__closeIcon--2GI7C{position:absolute;top:0;right:0;color:#212121}@media screen and (min-width:1152px){.article-reactions-widget-module__closeIcon--2GI7C{cursor:pointer}}.article-reactions-widget-module__closeIcon--2GI7C svg{width:24px;height:24px}.article-reactions-widget-module__title--3KJJ1{margin-bottom:15px}", ""]);
// Exports
exports.locals = {
	"container": "article-reactions-widget-module__container--1gg_-",
	"closeIcon": "article-reactions-widget-module__closeIcon--2GI7C",
	"title": "article-reactions-widget-module__title--3KJJ1"
};
module.exports = exports;
